/**
 * Termination Workflow Machine Config
 *
 * Spec: Documentation/Specification/04_Processes/application-specific/hr/OffboardingProcess.md
 * States: draft → noticeIssued → noticePeriod → finalDay → settlementPending → completed
 */
export const terminationConfig = {
    id: 'termination',
    initial: 'draft',
    states: {
        draft: {
            on: { ISSUE_NOTICE: { target: 'noticeIssued', guard: 'noticeDateValid' } },
        },
        noticeIssued: {
            entry: { type: 'sendNoticeEmail' },
            on: { NOTICE_PERIOD_START: 'noticePeriod' },
        },
        noticePeriod: {
            on: { FINAL_DAY_REACHED: { target: 'finalDay', guard: 'noticePeriodComplete' } },
        },
        finalDay: {
            entry: { type: 'calculateSettlement' },
            on: { SETTLEMENT_GENERATED: 'settlementPending' },
        },
        settlementPending: {
            on: { SETTLEMENT_SIGNED: { target: 'completed', guard: 'settlementSigned' } },
        },
        completed: {
            entry: { type: 'processSettlement' },
            type: 'final',
        },
    },
};
//# sourceMappingURL=termination.js.map